import GET from './get'
import POST from './post'

const ENDPOINT = {
  ...GET,
  ...POST,
}
export default ENDPOINT
